(function (win, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (win && win.document && !win.K2CartProtectionCharge) {
    win.K2CartProtectionCharge = api;
    api.mount(win);
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function moneyCents(text, currency) {
    if (currency !== 'USD') return null;
    var value = String(text || '').replace(/\s+/g, '').replace(/^(?:USD)?(?:US)?\$/, '').replace(/^USD/, '').replace(/USD$/, '');
    if (!/^(?:\d{1,3}(?:,\d{3})*|\d+)\.\d{2}$/.test(value)) return null;
    var cents = Number(value.replace(/[,\.]/g, ''));
    return Number.isSafeInteger(cents) && cents >= 0 ? cents : null;
  }
  function isProtection(item) {
    return !!item && (item.product_type === 'sam_protect_shipping' || !item.product_type && !item.handle && !item.product_id);
  }
  function merchandiseSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart.items.filter(function (item) { return !isProtection(item); }).map(function (item) { return item.key + ':' + item.quantity + ':' + item.final_line_price + '|'; }).join('');
  }
  function totalFor(cart, selection) {
    if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return null;
    if (selection && selection.absent) return cart.total_price;
    var included = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isProtection(cart.items[i])) continue;
      var amount = cart.items[i].final_line_price;
      if (!Number.isSafeInteger(amount) || amount < 0) return null;
      included += amount;
    }
    if (included > cart.total_price || !selection || selection.loading || selection.ambiguous) return null;
    var quote = selection.checked ? moneyCents(selection.text, cart.currency) : 0;
    if (quote === null) return null;
    var total = cart.total_price - included + quote;
    return Number.isSafeInteger(total) && total >= 0 ? total : null;
  }
  function selectionFor(drawer, win) {
    var inputs = drawer.querySelectorAll('input.sam_switch_btn');
    if (!inputs.length) return { absent: true, checked: false, text: '', widget: null, loading: false };
    if (inputs.length !== 1) return { ambiguous: true, loading: true };
    var widget = inputs[0].closest('.sam__widget');
    if (!widget) return { ambiguous: true, loading: true };
    var prices = widget.querySelectorAll('.sam-protect-estimate .money');
    var loading = !!widget.querySelector('.sam-price-loading');
    var price = prices.length === 1 ? prices[0] : null;
    var text = price ? (price.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (price && (price.closest('[hidden]') || win.getComputedStyle && /^(none|hidden)$/.test(win.getComputedStyle(price).display))) loading = true;
    if (price && win.getComputedStyle && win.getComputedStyle(price).visibility === 'hidden') loading = true;
    return { checked: !!inputs[0].checked, text: text, widget: widget, loading: loading || !!inputs[0].checked && (!price || !/\d/.test(text)), ambiguous: prices.length > 1 };
  }
  function mount(win) {
    var doc = win.document, drawer = null, observer = null, timer = null, generation = 0, cartUpdating = false;
    function owned(node) {
      var element = node && (node.nodeType === 3 ? node.parentElement : node);
      return !!(element && element.closest && element.closest('[data-k2-checkout-amount], [data-k2-protection-charge]'));
    }
    function meaningful(record) {
      if (owned(record.target)) return false;
      var nodes = Array.prototype.slice.call(record.addedNodes || []).concat(Array.prototype.slice.call(record.removedNodes || []));
      return !nodes.length || !nodes.every(owned);
    }
    function hideAmount() {
      if (!drawer) return;
      var amount = drawer.querySelector('[data-k2-checkout-amount]');
      if (amount && !amount.hidden) amount.hidden = true;
      drawer.querySelectorAll('[data-k2-protection-charge]').forEach(function (caption) { if (!caption.hidden) caption.hidden = true; });
    }
    function fallback(selection) {
      if (!selection || selection.loading || selection.ambiguous || !selection.checked || !selection.widget || !selection.text) return;
      var caption = selection.widget.querySelector('[data-k2-protection-charge]');
      if (!caption) {
        caption = doc.createElement('p');
        caption.setAttribute('data-k2-protection-charge', '');
        caption.setAttribute('role', 'status');
        caption.setAttribute('aria-live', 'polite');
        caption.style.cssText = 'font-size:13px;line-height:1.3;margin:2px 0 0;';
        selection.widget.appendChild(caption);
      }
      var text = '+ ' + selection.text + ' shipping protection';
      if (caption.textContent !== text) caption.textContent = text;
      if (caption.hidden) caption.hidden = false;
    }
    async function sync(version) {
      timer = null;
      var target = drawer;
      if (!target || !target.isConnected || cartUpdating) return;
      var button = target.querySelector('[data-k2-checkout-total]');
      var amount = target.querySelector('[data-k2-checkout-amount]');
      if (!button || !amount) return;
      var selection = selectionFor(target, win);
      if (selection.loading || selection.ambiguous) return;
      var root = button.getAttribute('data-cart-root') || '/';
      if (root.charAt(0) !== '/' || root.indexOf('//') === 0) return;
      try {
        var response = await win.fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart unavailable');
        var cart = await response.json();
        if (version !== generation || drawer !== target || !target.isConnected || cartUpdating) return;
        var now = selectionFor(target, win);
        if (now.loading || now.ambiguous || now.checked !== selection.checked || now.text !== selection.text) return;
        if (merchandiseSignature(cart) !== button.getAttribute('data-cart-merchandise')) return;
        var currency = button.getAttribute('data-cart-currency');
        var total = currency === cart.currency ? totalFor(cart, now) : null;
        if (total === null) { fallback(now); return; }
        var formatted = new Intl.NumberFormat(button.getAttribute('data-cart-locale') || 'en', { style: 'currency', currency: currency }).format(total / 100);
        var value = ' – ' + formatted;
        if (amount.textContent !== value) amount.textContent = value;
        if (amount.hidden) amount.hidden = false;
      } catch (_) {
        if (version === generation && drawer === target && target.isConnected && !cartUpdating) fallback(selectionFor(target, win));
      }
    }
    function schedule() {
      generation++;
      hideAmount();
      win.clearTimeout(timer);
      var version = generation;
      timer = win.setTimeout(function () { sync(version); }, 180);
    }
    function scan() {
      var next = doc.getElementById('cart-drawer');
      if (next !== drawer) {
        if (observer) observer.disconnect();
        drawer = next;
        if (drawer) {
          observer = new win.MutationObserver(function (records) { if (records.some(meaningful)) schedule(); });
          observer.observe(drawer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['checked', 'class', 'style', 'hidden', 'aria-hidden', 'aria-busy', 'disabled'] });
        }
      }
      cartUpdating = false;
      schedule();
    }
    function selectedStateChanged(event) {
      var target = event.target;
      if (!drawer || !target.closest || target.closest('#cart-drawer') !== drawer) return;
      if (target.closest('.sam__widget, input.sam_switch_btn')) { schedule(); return; }
      if (target.closest('quantity-input, .quantity, [name="updates[]"], a[href*="/cart/change"]')) { cartUpdating = true; schedule(); }
    }
    doc.addEventListener('change', selectedStateChanged, true);
    doc.addEventListener('click', selectedStateChanged, true);
    ['on:cart:after-merge', 'on:line-item:change', 'on:cart:error', 'cart:refresh', 'shopify:section:load'].forEach(function (event) { doc.addEventListener(event, scan); });
    win.addEventListener('pageshow', scan);
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', scan, { once: true });
    else scan();
  }
  return { moneyCents: moneyCents, isProtection: isProtection, merchandiseSignature: merchandiseSignature, totalFor: totalFor, selectionFor: selectionFor, mount: mount };
});
